import { hbs } from 'ember-cli-htmlbars';
const __COLOCATED_TEMPLATE__ = hbs("<li\n  class={{concat-classes\n    \"eLib--boardItem cLIB--boardItem ember-view ui-draggable ui-draggable-handle qa--media_library_item\"\n    (if this.hasMultipleSelectedMedia \"has--multi\")\n    (if @mediaItem.isTestImage \"at--testImgTour__upload\")\n  }}\n  data-media-item-id={{@mediaItem.id}}\n  data-media-item-is-test-image={{@mediaItem.isTestImage}}\n  data-media-item-small-thumb={{this.smallThumbnailOrProcessingUrl}}\n  data-media-item-thumb={{this.thumbUrl}}\n  data-test-id={{@data-test-id}}\n  {{did-insert this.createProgressBar}}\n  {{did-update this.uploadProgress @mediaItem.uploadProgress @mediaItem.isUploading}}\n  {{draggable\n    useCopy=true\n    onDragStart=@onDragStart\n    onDragEnd=@onDragEnd\n    isFullCalendarDraggable=true\n    isDisabled=this.isCalendarSelectMode\n  }}\n>\n  <figure class=\"o--mediaContainer\" data-test-id=\"container\">\n    {{#if @mediaItem.isUploading}}\n      <div class=\"e--upload-progress\" data-test-id=\"uploading background\"></div>\n    {{else}}\n      <Shared::Image\n        @picture={{hash sources=@mediaItem.sideLibraryImageUrl}}\n        class=\"o--media {{if this.isBeingDragged 'u--mute'}} {{if this.isSelected 'is--selected'}}\"\n        data-test-id=\"media image\"\n        {{on \"error\" this.checkImages}}\n      />\n      <b class=\"o--mediaOverlay\" data-test-id=\"overlay\" {{on \"click\" this.toggleOrOpenItem}}></b>\n      {{! Note: IF not yet approved by the owner of the original media, request to use image already sent }}\n      {{#if @mediaItem.needsApproval}}\n        <span class=\"o--mediaOverlay\">\n          <span class=\"img--overlay__pending\" data-test-id=\"pending overlay\"></span>\n        </span>\n      {{/if}}\n      {{#if @mediaItem.isVideo}}\n        <span class=\"o--media__label--type\" data-test-id=\"video overlay\">\n          {{svg-jar \"video\" class=\"o--icon--md o--icon--white\"}}\n        </span>\n      {{/if}}\n      {{#if @mediaItem.isGif}}\n        <span class=\"o--media__label--type\" data-test-id=\"gif overlay\">\n          {{svg-jar \"gif\" class=\"o--icon--md o--icon--white\"}}\n        </span>\n      {{/if}}\n      {{#if @mediaItem.hasPosts}}\n        <span class=\"o--media__label--status\" data-test-id=\"post count\">\n          {{@mediaItem.postCount}}\n        </span>\n      {{/if}}\n      {{#if @enableMultiSelect}}\n        {{!  Checkbox }}\n        <span\n          class=\"o--media__label--select\n            {{if (eq @mediaItemOrder 0) 'at--quickSchedule__mediaSelect at--quickSchedule__mediaSelect--latam'}}\"\n        >\n          <span data-test-id=\"select\" {{on \"click\" this.toggleSelection}}>\n            {{#if this.isSelected}}\n              {{svg-jar\n                \"verified\"\n                class=\"o--icon o--icon--white o--media__labelIcon is--checked qa--mediaItem_select_label\"\n                data-test-id=\"selection visual\"\n              }}\n            {{else}}\n              {{svg-jar\n                \"verified\"\n                class=\"o--icon o--icon--white o--media__labelIcon is--visible qa--mediaItem_select_label\"\n                data-test-id=\"selection visual\"\n              }}\n            {{/if}}\n          </span>\n        </span>\n      {{/if}}\n    {{/if}}\n  </figure>\n  <div class=\"cLIB--boardItem__counter\">\n    {{this.draggedAssetNumber}}\n  </div>\n</li>", {"contents":"<li\n  class={{concat-classes\n    \"eLib--boardItem cLIB--boardItem ember-view ui-draggable ui-draggable-handle qa--media_library_item\"\n    (if this.hasMultipleSelectedMedia \"has--multi\")\n    (if @mediaItem.isTestImage \"at--testImgTour__upload\")\n  }}\n  data-media-item-id={{@mediaItem.id}}\n  data-media-item-is-test-image={{@mediaItem.isTestImage}}\n  data-media-item-small-thumb={{this.smallThumbnailOrProcessingUrl}}\n  data-media-item-thumb={{this.thumbUrl}}\n  data-test-id={{@data-test-id}}\n  {{did-insert this.createProgressBar}}\n  {{did-update this.uploadProgress @mediaItem.uploadProgress @mediaItem.isUploading}}\n  {{draggable\n    useCopy=true\n    onDragStart=@onDragStart\n    onDragEnd=@onDragEnd\n    isFullCalendarDraggable=true\n    isDisabled=this.isCalendarSelectMode\n  }}\n>\n  <figure class=\"o--mediaContainer\" data-test-id=\"container\">\n    {{#if @mediaItem.isUploading}}\n      <div class=\"e--upload-progress\" data-test-id=\"uploading background\"></div>\n    {{else}}\n      <Shared::Image\n        @picture={{hash sources=@mediaItem.sideLibraryImageUrl}}\n        class=\"o--media {{if this.isBeingDragged 'u--mute'}} {{if this.isSelected 'is--selected'}}\"\n        data-test-id=\"media image\"\n        {{on \"error\" this.checkImages}}\n      />\n      <b class=\"o--mediaOverlay\" data-test-id=\"overlay\" {{on \"click\" this.toggleOrOpenItem}}></b>\n      {{! Note: IF not yet approved by the owner of the original media, request to use image already sent }}\n      {{#if @mediaItem.needsApproval}}\n        <span class=\"o--mediaOverlay\">\n          <span class=\"img--overlay__pending\" data-test-id=\"pending overlay\"></span>\n        </span>\n      {{/if}}\n      {{#if @mediaItem.isVideo}}\n        <span class=\"o--media__label--type\" data-test-id=\"video overlay\">\n          {{svg-jar \"video\" class=\"o--icon--md o--icon--white\"}}\n        </span>\n      {{/if}}\n      {{#if @mediaItem.isGif}}\n        <span class=\"o--media__label--type\" data-test-id=\"gif overlay\">\n          {{svg-jar \"gif\" class=\"o--icon--md o--icon--white\"}}\n        </span>\n      {{/if}}\n      {{#if @mediaItem.hasPosts}}\n        <span class=\"o--media__label--status\" data-test-id=\"post count\">\n          {{@mediaItem.postCount}}\n        </span>\n      {{/if}}\n      {{#if @enableMultiSelect}}\n        {{!  Checkbox }}\n        <span\n          class=\"o--media__label--select\n            {{if (eq @mediaItemOrder 0) 'at--quickSchedule__mediaSelect at--quickSchedule__mediaSelect--latam'}}\"\n        >\n          <span data-test-id=\"select\" {{on \"click\" this.toggleSelection}}>\n            {{#if this.isSelected}}\n              {{svg-jar\n                \"verified\"\n                class=\"o--icon o--icon--white o--media__labelIcon is--checked qa--mediaItem_select_label\"\n                data-test-id=\"selection visual\"\n              }}\n            {{else}}\n              {{svg-jar\n                \"verified\"\n                class=\"o--icon o--icon--white o--media__labelIcon is--visible qa--mediaItem_select_label\"\n                data-test-id=\"selection visual\"\n              }}\n            {{/if}}\n          </span>\n        </span>\n      {{/if}}\n    {{/if}}\n  </figure>\n  <div class=\"cLIB--boardItem__counter\">\n    {{this.draggedAssetNumber}}\n  </div>\n</li>","moduleName":"later/components/media-items/media-item.hbs","parseOptions":{"srcName":"later/components/media-items/media-item.hbs"}});
import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import { service } from '@ember/service';
import { isNone } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import ProgressBar from 'progressbar.js';

import { CALENDAR_TYPES } from 'later/utils/constants';

const { SELECT } = CALENDAR_TYPES;

export default class MediaItemComponent extends Component {
  @service('calendar/config') calendarConfig;
  @tracked circle;

  get draggedAssetNumber() {
    return this.args.selectedAssets?.length || 1;
  }

  get thumbUrl() {
    return this.args.mediaItem.thumbUrl;
  }

  get smallThumbnailOrProcessingUrl() {
    return this.args.mediaItem.smallThumbnailOrProcessingUrl;
  }

  get hasMultipleSelectedMedia() {
    return this.args.selectedAssets?.length > 1;
  }

  get isBeingDragged() {
    return this.args.isDragging && this.isSelected;
  }

  get isSelected() {
    if (isNone(this.args.selectedAssets)) {
      return false;
    }
    return this.args.enableMultiSelect && this.args.selectedAssets.includes(this.args.mediaItem);
  }

  get isCalendarSelectMode() {
    return this.calendarConfig.calendarType === SELECT;
  }

  @action
  uploadProgress() {
    const uploadProgress = () => {
      if (this.args.mediaItem.isUploading) {
        if (isNone(this.circle)) {
          const circle = new ProgressBar.Circle(document.querySelector('.e--upload-progress'), {
            svgStyle: {
              position: 'absolute',
              top: '35%',
              left: '35%',
              width: '30%'
            },
            color: '#BFC9D3',
            strokeWidth: 5,
            trailWidth: 5
          });

          this.circle = circle;
        }
        this.circle.animate(this.args.mediaItem.uploadProgress);
      }
    };

    scheduleOnce('afterRender', this, uploadProgress);
  }

  @action
  createProgressBar() {
    if (this.args.mediaItem.isUploading) {
      const circle = new ProgressBar.Circle(document.querySelector('.e--upload-progress'), {
        svgStyle: {
          position: 'absolute',
          top: '35%',
          left: '35%',
          width: '30%'
        },
        color: '#BFC9D3',
        strokeWidth: 5,
        trailWidth: 5
      });

      this.circle = circle;
    }
  }

  @action
  checkImages() {
    if (!isNone(this.args.mediaItem)) {
      //I don't like this hack; but until we have tests sorted its what we need to do -iMack
      this.args.mediaItem.checkImages();
    }
  }

  @action
  toggleSelection() {
    if (this.isSelected) {
      this.args.removeSelection(this.args.mediaItem);
    } else {
      this.args.addSelection(this.args.mediaItem);
    }
  }

  @action
  toggleOrOpenItem(event) {
    if (this.args.mediaItem.isUploading) {
      return;
    }

    if (this.args.enableMultiSelect && (event.altKey || event.metaKey)) {
      this.toggleSelection();
    } else {
      this.args.openMediaItem(this.args.mediaItem);
    }
  }
}
